import React from 'react';
import { Users, Shield } from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const TermsClients = () => {
  const sections = [
    {
      title: '1. Objet',
      content: 'Les présentes CGU définissent les conditions d\'accès et d\'utilisation de la plateforme IPTV4KFR par les clients abonnés.'
    },
    {
      title: '2. Accès au service',
      content: (
        <div>
          <p className="mb-3">L'accès au service est conditionné à :</p>
          <ul className="space-y-2 ml-4">
            <li className="flex items-start space-x-2">
              <span className="text-[#FF6B35] mt-1">•</span>
              <span>La création d'un compte client</span>
            </li>
            <li className="flex items-start space-x-2">
              <span className="text-[#FF6B35] mt-1">•</span>
              <span>La souscription à un abonnement actif</span>
            </li>
          </ul>
          <p className="mt-3 text-[#FFB800]">Les identifiants fournis sont strictement personnels.</p>
        </div>
      )
    },
    {
      title: '3. Utilisation du service',
      content: (
        <div>
          <p className="mb-3">Le client s'engage à :</p>
          <ul className="space-y-2 ml-4">
            <li className="flex items-start space-x-2">
              <span className="text-[#00FF88] mt-1">✓</span>
              <span>Utiliser le service conformément aux instructions fournies</span>
            </li>
            <li className="flex items-start space-x-2">
              <span className="text-[#00FF88] mt-1">✓</span>
              <span>Ne pas partager ses accès de manière abusive</span>
            </li>
            <li className="flex items-start space-x-2">
              <span className="text-[#00FF88] mt-1">✓</span>
              <span>Respecter les limites d'utilisation précisées dans son espace client</span>
            </li>
          </ul>
        </div>
      )
    },
    {
      title: '4. Abonnement',
      content: (
        <div>
          <p className="mb-3">L'abonnement est :</p>
          <ul className="space-y-2 ml-4">
            <li className="flex items-start space-x-2">
              <span className="text-[#FF6B35] mt-1">•</span>
              <span><strong>Annuel</strong></span>
            </li>
            <li className="flex items-start space-x-2">
              <span className="text-[#FF6B35] mt-1">•</span>
              <span><strong>Personnel</strong></span>
            </li>
            <li className="flex items-start space-x-2">
              <span className="text-[#FF6B35] mt-1">•</span>
              <span><strong>Non transférable</strong> sauf accord explicite</span>
            </li>
          </ul>
          <p className="mt-3">Les modalités de renouvellement et de gestion sont accessibles depuis l'espace client.</p>
        </div>
      )
    },
    {
      title: '5. Support & accompagnement',
      content: (
        <div>
          <p className="mb-3">Un support est mis à disposition pour accompagner le client dans :</p>
          <ul className="space-y-2 ml-4">
            <li className="flex items-start space-x-2">
              <span className="text-[#00FF88] mt-1">•</span>
              <span>L'installation</span>
            </li>
            <li className="flex items-start space-x-2">
              <span className="text-[#00FF88] mt-1">•</span>
              <span>L'utilisation</span>
            </li>
            <li className="flex items-start space-x-2">
              <span className="text-[#00FF88] mt-1">•</span>
              <span>La compréhension des fonctionnalités</span>
            </li>
          </ul>
        </div>
      )
    },
    {
      title: '6. Responsabilité de l\'utilisateur',
      content: (
        <div>
          <p className="mb-3">Le client est responsable :</p>
          <ul className="space-y-2 ml-4">
            <li className="flex items-start space-x-2">
              <span className="text-[#FFB800] mt-1">•</span>
              <span>De son matériel</span>
            </li>
            <li className="flex items-start space-x-2">
              <span className="text-[#FFB800] mt-1">•</span>
              <span>De sa connexion internet</span>
            </li>
            <li className="flex items-start space-x-2">
              <span className="text-[#FFB800] mt-1">•</span>
              <span>De l'application utilisée pour accéder au service</span>
            </li>
          </ul>
        </div>
      )
    },
    {
      title: '7. Suspension ou résiliation',
      content: 'IPTV4KFR se réserve le droit de suspendre ou résilier un accès en cas d\'utilisation abusive ou non conforme.'
    },
    {
      title: '8. Modification des CGU',
      content: 'Les CGU peuvent être mises à jour. La version applicable est celle en vigueur au moment de l\'utilisation.'
    }
  ];

  return (
    <div className="min-h-screen py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <div className="inline-block p-4 bg-[#00FF88]/10 rounded-full mb-6">
            <Users className="h-12 w-12 text-[#00FF88]" />
          </div>
          <h1 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Conditions Générales d'Utilisation
          </h1>
          <p className="text-[#B8B8BA] text-lg mb-2">
            Pour les clients
          </p>
        </motion.div>

        <div className="space-y-6">
          {sections.map((section, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.05 * index }}
              className="bg-gradient-to-br from-[#1A1A1D] to-[#121214] p-6 rounded-xl border border-white/10"
            >
              <h2 className="text-xl font-bold text-white mb-3">
                {section.title}
              </h2>
              <div className="text-[#E8E8E8] leading-relaxed">
                {section.content}
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="mt-12 text-center"
        >
          <p className="text-[#B8B8BA] mb-4">
            Des questions sur ces conditions ?
          </p>
          <Link
            to="/faq"
            className="text-[#FF6B35] hover:text-[#F7931E] font-semibold transition-colors"
          >
            Consultez notre FAQ →
          </Link>
        </motion.div>
      </div>
    </div>
  );
};

export default TermsClients;
